export default "__VITE_ASSET__BBr1odTZ__"